import React, { useEffect } from "react";
import '../../../../styles/superAdmin/modal.css';
import { AiOutlineCheckCircle, AiOutlineClose } from 'react-icons/ai';



const SuccessPopup = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="popup-wrapper">
      <div className="popup success">
        <div className="popup-content">
          <div className="popup-left">
            <AiOutlineCheckCircle className="icon success-icon" size={18} />
            <div className="popup-text">
              <p className="main">{message}</p>
            </div>
          </div>
          <button onClick={onClose} className="popup-close">
            <AiOutlineClose className="icon close-icon" size={17}/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;
